<template mlns="http://www.w3.org/1999/html">
  <div style="font-family: PingFangSC-Regular, 微软雅黑;" v-loading="initLoading">
    <div style="padding: 20px;position: relative">
      <div style="font-size: 20px">
        <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
          <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/salePunchInfo' }">在店打卡明细</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="font-size: 25px;margin-top: 10px;">
        <p>在店打卡明细表</p>
      </div>

      <div style="width: 100%; font-size: 25px">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="100px"
                 style="margin-top: 10px;width: 300px">
          <el-form-item label="供应商" prop="supplierId">
            <el-select popper-class="el-select" v-model="ruleForm.supplierId" value-key="id" placeholder="请选择供应商"
                       style="width: 400px" multiple clearable>
              <select-all-option v-model="ruleForm.supplierId" :data="supplierList" data-value="id" :autoSelect="true"/>
              <el-option
                v-for="item in supplierList"
                :key="item.id"
                :label="item.name"
                :value='item.id'>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="时间选择" style="width: 465px;" required>
            <el-col :span="11">
              <el-form-item prop="startDate">
                <el-date-picker
                  v-model="ruleForm.startDate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  :picker-options="start" style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">&nbsp;&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item prop="endDate">
                <el-date-picker
                  v-model="ruleForm.endDate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="结束日期"
                  :picker-options="end" style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="在店状态" style="width: 465px;" prop="status">
            <el-radio-group v-model="ruleForm.status">
              <el-radio :label="0">全选</el-radio>
              <el-radio :label="1">在店打卡</el-radio>
              <el-radio :label="2">店外打卡</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="打卡来源" style="width: 465px;" prop="type">
            <el-radio-group v-model="ruleForm.type">
              <el-radio :label="0">全选</el-radio>
              <el-radio :label="1">自动打卡</el-radio>
              <el-radio :label="2">手动打卡</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item>
            <el-button
              class="button" :loading="loading"
              @click="download('ruleForm')">导出excel
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {downloadExcel,getSupplierList} from "@/api/SalePunchInfo"
import selectAllOption from "@/components/selectAllOption";

export default {
  name: "SalePunchInfo",
  components: {selectAllOption},
  data() {
    return {
      token: '',
      loading: false,
      initLoading: true,
      rules: {
        supplierId: [
          {required: true, message: '请至少选择一个供应商', trigger: 'change'}
        ],
        startDate: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        endDate: [
          { required: true, message: '请选择时间', trigger: 'change' }
        ],
      },
      start: {
        disabledDate: (time) => {
          if (this.ruleForm.endDate) {
            return time.getTime() > new Date(this.ruleForm.endDate).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      end: {
        disabledDate: (time) => {
          if (this.ruleForm.startDate) {
            return (time.getTime() < new Date(this.ruleForm.startDate).getTime() || time.getTime() > Date.now())
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      supplierList: [],
      ruleForm: {
        supplierId: [],
        startDate: '',
        endDate: '',
        status: 0,
        type: 0
      },
    }
  },
  mounted() {
    this.token = localStorage.getItem('token')
    this.initLoading = true;
    getSupplierList(this.token).then(res => {
      if (res.data.code == 200) {
        this.supplierList = res.data.date
        if (this.supplierList.length == 1) {
          this.supplier = this.supplierList;
        }
      }
      this.initLoading = false;
    }).catch(error => {
      let status = error.response.status;
      if (status == 500) {
        this.$notify.error({
          title: '错误',
          message: '查询失败，请联系管理员',
          position: 'bottom-right'
        })
      }
    })
  },
  methods: {
    download(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          downloadExcel(this.token, this.ruleForm).then(res => {
            this.handleDownload(res)
            this.$notify.success({
              type: 'success',
              title: '成功',
              message: '导出成功',
              position: 'bottom-right'
            })
          }).catch(error => {
            let status = error.response.status;
            if (status == 500) {
              this.$notify.error({
                type: 'error',
                title: '错误',
                message: '导出失败，请联系管理员',
                position: 'bottom-right'
              })
            }
          }).finally(() => {
            this.loading = false
          })
        }
      });
    },
    handleDownload(res) {
      let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>

<style scoped>

.button {
  color: white !important;
  background: #ff6633 !important;
}

</style>
